import { emojiSliderWidgetStore } from '../store';
import { useSelectedFieldStore } from './useSelectedFieldStore';

export type UseUserSliderMagnitudeArg = {
  widgetId: string;
};

export function useUserSliderMagnitude({
  widgetId,
}: UseUserSliderMagnitudeArg): number | undefined {
  return useSelectedFieldStore(
    emojiSliderWidgetStore,
    () => emojiSliderWidgetStore.get()[widgetId]?.magnitude
  );
}
